<template>
  <div :class="fieldStyling">
    <div class="field__label flex items-center justify-between">
      <FieldLabel :field="field" />
      <ErrorMessage
        v-if="errors"
        :error="errorMessage"
      />
    </div>
    <div
      v-for="option in options"
      :key="getOptionId(option)"
    >
      <input
        :id="getOptionId(option)"
        v-model="value"
        type="radio"
        :name="getOptionId(option)"
        :value="option"
        :disabled="isDisabled"
      >
      <label
        :for="getOptionId(option)"
        class="checkbox"
        v-text="option"
      />
    </div>
    <HelpText
      v-if="field.attributes.help"
      :help-text="field.attributes.help"
      class="pt-4"
    />
  </div>
</template>

<script type="text/babel">
import HelpText from './HelpText'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'
import inputField from 'FormBuilder/Resources/assets/js/mixins/input-field.js'

export default {
  name: 'RadioField',
  components: {
    FieldLabel,
    ErrorMessage,
    HelpText,
  },
  mixins: [inputField],
  computed: {
    options() {
      return this.field.attributes.field_meta.options
    },
  },
  methods: {
    getOptionId(option) {
      return `${this.field.attributes.slug}-${option}`
    },
  },
}
</script>
